module.exports = __webpack_public_path__ + "static/step2-2187218cda1f24e8c7d6e4e40e47325d.png";